import HcsNavBarItem from "./hcs-navbar-item";

export default class HcsNavBarItemWelcome extends HcsNavBarItem {
    constructor(props) {
        super(props);
        this.groupChanged = this.groupChanged.bind(this);
    }

    groupChanged() {
        const { hcs } = this.props;

        hcs.cfgEngine.welcomeClicked.call();
    }

    itemClasses() {
        return [ "hcs-welcome-section" ];
    }
}